import ouiBase from '@goldwasserexchange/oui';
import { useAccountCashflowFieldApiByCpsHisId } from '../api';

export const useAccountCashflowsGesEstimDQt = () => {
  const cpsHisId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const result = useAccountCashflowFieldApiByCpsHisId({
    cpsHisId,
    field: 'GES_ESTIM_D.QT',
  });
  return result;
};
